// extracted by mini-css-extract-plugin
export var container = "ArticlePreview-module--container--ee293";
export var content = "ArticlePreview-module--content--a0062";
export var image = "ArticlePreview-module--image--e9eb6";
export var latest = "ArticlePreview-module--latest--a6599";
export var readMore = "ArticlePreview-module--read-more--cb5f9";
export var root = "ArticlePreview-module--root--3cd17";
export var title = "ArticlePreview-module--title--8b5aa";